import React from 'react'

export default class IconLogoBluehost extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'

        return (
            <svg
                className={className}
                style={this.props.style}
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <rect width='24' height='24' rx='6' fill='white' />
                <g clipPath='url(#clip0_391_40379)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M21.81 7.57583V2H16.2758V7.57583H21.81ZM21.81 9.21167V14.7883H16.2758V9.21167H21.81ZM7.53167 22V16.4233H2V22H7.53167ZM14.6708 16.4233V22H9.13667V16.4233H14.6708ZM21.81 16.4233V22H16.2758V16.4233H21.81ZM14.6708 14.7883V9.21167H9.13667V14.7883H14.6708ZM7.53167 9.21167V14.7883H2V9.21167H7.53167ZM14.6667 2V7.57583H9.13667V2H14.6667ZM7.53167 7.57583V2H2V7.57583H7.53167Z'
                        fill='#196BDE'
                    />
                </g>
                <defs>
                    <clipPath id='clip0_391_40379'>
                        <rect width='20' height='20' fill='white' transform='translate(2 2)' />
                    </clipPath>
                </defs>
            </svg>
        )
    }
}
